import { ResultsCard } from 'libs/searchspring/components/ResultCard'

export const ResultItem = ({ item, className, dataIndex }) => {
  if ('value' in item) {
    return <div className="result-card" dangerouslySetInnerHTML={{ __html: item.value }} />
  }

  return (
    <ResultsCard
      result={item}
      className={className}
      dataIndex={dataIndex}
    />
  )
}
